// Lib
import * as Immutable from 'immutable';

// Utils
import getClientConfig from '../../utils/getClientConfig';

// Constants
import { VERSION_UPDATE_AVAILABLE } from './versionConstants';

// TODO: Remove this state in favour of the version info in PlatformDetails, update the PWA to use PlatformDetails

const initialState = Immutable.Map({
    currentVersion: getClientConfig().appVersion,
    updateAvailable: false,
    isCurrentVersionSafe: true,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case VERSION_UPDATE_AVAILABLE:
            return state.set('updateAvailable', true).set('isCurrentVersionSafe', action.safe);
        default:
            return state;
    }
};
